import React from 'react'
import styled from 'styled-components'
import { LargeWrapper } from '@raysync/common/components'
import { Devices } from '@raysync/common/theme'
import { Title, Desc } from '../atoms'
const Section = styled.section`
  padding: 80px 0 70px;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 0.7rem;
  }
`

const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin-top: 46px;
  @media ${Devices.phone} {
    margin-top: 0.5rem;
  }
`

const Item = styled.div`
  width: 448px;
  height: 300px;
  padding: 48px 26px 10px 38px;
  margin-bottom: 30px;
  border: 1px solid #e2e5e7;
  border-radius: 20px;
  @media ${Devices.phone} {
    width: 100%;
    height: unset;
    margin-bottom: 0.3rem;
    padding: 0.36rem 0.3rem;
    box-shadow: 0px 0px 0.4rem 0px #e2e7ec;
    border-radius: 10px;
  }
`

const ItemIcon = styled.div`
  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 30px;
  }

  @media ${Devices.phone} {
    svg {
      width: 0.5rem;
      height: 0.5rem;
      margin-bottom: 0.3rem;
    }
  }
`

const ItemContent = styled.div`
  h3 {
    display: block;
    font-size: 24px;
    line-height: 1;
    margin-bottom: 12px;
    font-weight: bold;
    color: ${p => p.theme.color.textDarkPlus};
  }
  p {
    font-size: 16px;
    line-height: 1.5;
    color: #636772;
  }

  @media ${Devices.phone} {
    margin-left: 0;
    h3 {
      font-size: 0.3rem;
      margin-bottom: 0.1rem;
    }
    p {
      font-size: 0.2rem;
    }
  }
`

const Advantages = ({ title, desc, items }) => {
  return (
    <Section>
      <LargeWrapper>
        <Title>{title}</Title>
        {desc && <Desc>{desc}</Desc>}
        <ItemsWrapper>
          {items.map((item, index) => (
            <Item key={index}>
              <ItemIcon>{item.svg}</ItemIcon>
              <ItemContent>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </ItemContent>
            </Item>
          ))}
        </ItemsWrapper>
      </LargeWrapper>
    </Section>
  )
}

export default Advantages
